// libs
import styled, { css } from 'styled-components'
// components
import MenuItemOrigin from '@mui/material/MenuItem'
// icons
import AddIconOrigin from '@mui/icons-material/Add'
import LinkIconOrigin from '@mui/icons-material/Link'
import AddLinkIconOrigin from '@mui/icons-material/AddLink'
import LinkOffIconOrigin from '@mui/icons-material/LinkOff'
import UndoIconOrigin from '@mui/icons-material/Undo'
import TrashIconOrigin from '@mui/icons-material/Delete'
import ObjectiveIconOrigin from '@mui/icons-material/TrackChanges'
import ActionIconOrigin from '@mui/icons-material/VerticalSplit'
import MeasureIconOrigin from 'src/icons/measures.svg'
import ArchiveIconOrigin from 'src/icons/archive.svg'
// themes
import { colors } from 'themes'
// utils
import { size } from 'polished'

// UI mirrored from RiskControlButtons (rounded pill with divided icon buttons).
export const ButtonsWrapper = styled.div`
  background-color: ${colors.white100};
  border-radius: 25px;
  border: 1px solid ${colors.blue500};
  display: inline-flex;
  align-items: center;
  height: 24px;
  width: fit-content;
  padding: 0 2px;

  > div:not(:last-child) {
    border-right: 1px solid ${colors.blue500};
  }

  > div {
    padding: 0 4px;
    min-width: 24px;
  }
`

export const Button = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  height: 24px;

  ${({ disabled }) =>
    disabled
      ? css`
          pointer-events: none;
          cursor: default;

          svg {
            path {
              fill: ${colors.gray320};
            }
          }
        `
      : css`
          cursor: pointer;

          &:hover {
            opacity: 0.7;
          }
        `}
`

export const MenuWrapper = styled.div`
  padding: 8px 0;
`

export const MenuItem = styled(MenuItemOrigin)`
  && {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${colors.blue500};
  }
`

export const ObjectiveIcon = styled(ObjectiveIconOrigin)`
  && {
    ${size('18px')};
    color: ${colors.blue500};
  }
`

export const ActionIcon = styled(ActionIconOrigin)`
  && {
    ${size('18px')};
    color: ${colors.blue500};
  }
`

export const MeasureIcon = styled(MeasureIconOrigin)`
  ${size('18px')};

  path {
    fill: ${colors.blue500};
  }
`

export const AddIcon = styled(AddIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

export const LinkIcon = styled(LinkIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

export const AddLinkIcon = styled(AddLinkIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

export const LinkOffIcon = styled(LinkOffIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.red500};
  }
`

export const UndoIcon = styled(UndoIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

export const TrashIcon = styled(TrashIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

export const ArchiveIcon = styled(ArchiveIconOrigin)`
  ${size('12px')};

  path {
    fill: ${colors.blue500};
  }
`
